import React from "react";

export default function Resourses() {
  return <div></div>;
}